import { IconStyled, IconStylesProps } from './IconStyles';

export const Error = ({
  size = 'base',
  className = '',
}: Partial<IconStylesProps>) => (
  <IconStyled
    size={size}
    width={size}
    height={size}
    className={className}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill='none' fillRule='evenodd'>
      <path d='M0 0L24 0 24 24 0 24z' />
      <path
        fill='currentColor'
        d='M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z'
      />
    </g>
  </IconStyled>
);
